
import moment from "moment";
import { computed, defineComponent } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "user-role-modal",
  methods: {
    moment(date) {
      return moment(date).format("MMM DD YYYY, h:mm a");
    },
  },
  setup() {
    const store = useStore();

    const currentUserEdit = computed(() => {
      return store.getters.currentUserEdit;
    });

    return {
      currentUserEdit,
    };
  },
});
